/** Busca global: cliente, tarefa, documento e pedido num campo só (até 8 de cada). */
import { z } from 'zod';
import { DataISO, Id } from './comum.js';

export const BuscaResposta = z.object({
  clientes: z.array(z.object({ id: Id, nome: z.string(), documento: z.string(), situacao: z.string() })),
  tarefas: z.array(z.object({ id: Id, titulo: z.string(), clienteNome: z.string().nullable(), competenciaLabel: z.string().nullable(), status: z.string(), vencimento: DataISO })),
  documentos: z.array(z.object({ id: Id, titulo: z.string(), clienteId: Id, clienteNome: z.string(), tarefaId: Id.nullable() })),
  pedidos: z.array(z.object({ id: Id, servico: z.string(), clienteNome: z.string(), status: z.string() })),
});
export type BuscaResposta = z.infer<typeof BuscaResposta>;
